<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [header]="editing ? 'Editar canal' : 'Nuevo canal'" [style]="{ width: '520px' }" (onHide)="close()">
  <form [formGroup]="form" (ngSubmit)="submit()" class="form-stack">
    <div class="field field-flex">
      <label for="key">*Clave (inmutable):</label>
      <input pInputText id="key" formControlName="key" placeholder="ej. lounn" />
      <small class="p-error" *ngIf="form.get('key')?.touched && form.get('key')?.invalid">Solo minúsculas, números y guion bajo.</small>
    </div>
    <div class="field field-flex">
      <label for="label">*Etiqueta:</label>
      <input pInputText id="label" formControlName="label" placeholder="ej. Lounn" />
    </div>
    <div class="field field-flex">
      <label for="actorRoleRequired">Rol del actor (opcional):</label>
      <p-dropdown inputId="actorRoleRequired" formControlName="actorRoleRequired" [options]="roleOptions" optionLabel="label" optionValue="value" [style]="{ width: '100%' }"></p-dropdown>
    </div>
    <div class="field field-flex">
      <label for="category">*Categoría (agrupación KPIs):</label>
      <p-dropdown inputId="category" formControlName="category" [options]="categoryOptions" optionLabel="label" optionValue="value" [style]="{ width: '100%' }"></p-dropdown>
    </div>
    <div class="field field-flex">
      <label for="description">Descripción:</label>
      <textarea pInputTextarea id="description" formControlName="description" rows="2"></textarea>
    </div>
    <div class="field">
      <p-checkbox formControlName="active" [binary]="true" inputId="active" label="Activo"></p-checkbox>
    </div>
    <div class="form-action">
      <button pButton type="submit" label="Guardar" icon="fa-solid fa-check" class="p-button-success" [disabled]="form.invalid" [style.width]="'100%'"></button>
    </div>
  </form>
</p-dialog>
